<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="border-t border-gray-200">
      <dl>
        <div
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500">
            {{ $t("attachment.file_1") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <show-image class="h-32 w-32" :imageName="attachment.file_1" />
            <!-- <show-image class="h-32 w-32" :imageName="attachment.imageDoc" v-else/> -->
          </dd>
        </div>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("attachment.createdAt") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ attachment.created_at }}
          </dd>
        </div>
        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("attachment.createdBy") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ attachment.created_by }}
          </dd>
        </div>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("attachment.updatedAt") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ attachment.updated_at }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("attachment.updatedBy") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ attachment.updated_by }}
          </dd>
        </div>
      </dl>
    </div>
  </div>

  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect, watch } from "vue";
import { mdiBallot, mdiPlusCircleOutline, mdiClose } from "@mdi/js";
import ShowImage from "@/components/ShowImage";
import axios from "axios";
import { axiosDocument } from "@/boot/axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ComboardAttachmentForm",
  components: {
    ShowImage,
    Loading,
  },
  props: {
    showEdit: {
      Boolean,
    },
    propAttach: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);
    const isLoading = ref(false);
    const attachment = reactive({
      id: "",
      comboard_id: "",
      title: "",
      file_1: "",
      imageDoc: "",
      created_at: "",
      created_by: "",
      updated_at: "",
      updated_by: "",
    });

    const getBase64 = async (attach) => {
      // getBase64Doc(attach)
      const params = { id: attach.id };
      if (attach.id) {
        await axios
          .get("/image", {
            params: params,
          })
          .then((res) => {
            attachment.file_1 = res.data.img;
          })
          .catch((error) => {
            getBase64Doc(attach);
          });
      }
    };

    const getBase64Doc = (attach) => {
      const params = { id: attach.id };
      axiosDocument
        .get("image-doc-comboard", {
          params: params,
        })
        .then((res) => {
          attachment.file_1 = res.data.data;
        });
    };

    watch(
      () => attachment.id,
      (newVal, oldVal) => {
        if (attachment.id != null) {
          // getBase64(attachment)
        }
      }
    );

    watchEffect(() => {
      const newAttach = props.propAttach;
      Object.assign(attachment, newAttach);
      if (attachment.id != null) {
        getBase64(attachment);
      }
    });

    return {
      titleStack,
      mdiBallot,
      mdiPlusCircleOutline,
      mdiClose,
      attachment,
      watchEffect,
      getBase64,
      isLoading,
    };
  },
  methods: {
    clearForm() {
      this.attachment = reactive({
        id: "",
        comboard_id: "",
        file_1: "",
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",
      });
    },
  },
};
</script>
